import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { PedidoService } from 'src/app/services/pedido.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { PerfectScrollbarComponent, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-atualizar-previsao-entrega-modal',
  templateUrl: './atualizar-previsao-entrega-modal.component.html',
  styleUrls: ['./atualizar-previsao-entrega-modal.component.scss']
})
export class AtualizarPrevisaoEntregaModalComponent implements OnInit {
  dataPrevisaoEntrega;
  idCupom: string;

  @ViewChild('perfectScrollPrevisao', { static: false }) perfectScroll: PerfectScrollbarComponent;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<AtualizarPrevisaoEntregaModalComponent>,
    private pedidoService: PedidoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService
  ) {
    this.idCupom = this.data.idCupom;
    this.dataPrevisaoEntrega = this.data.dataPrevisaoEntrega;
  }

  ngOnInit(): void {
  }

  salvar() {
    this.carregandoService.mostra('salvar');
    this.pedidoService.atualizarPrevisaoEntrega(this.idCupom, this.dataPrevisaoEntrega).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Previsão de entrega salva com sucesso!!!');
        this.dialogRef.close(this.dataPrevisaoEntrega);
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
